import ReportForm from '../components/Report/Form'

export default [
  {
    path: '/reports',
    name: 'reportEditStep1',
    component: ReportForm,
    props: {
      step: 1,
    },
    meta: {
      breadcrumbs: [
        { text: 'E. 報告書の出力' },
        { text: '詳細表の選択' },
      ],
    },
  },
  {
    path: '/reports/:id/step2',
    name: 'reportEditStep2',
    component: ReportForm,
    props: route => ({
      step: 2,
      id: route.params.id,
    }),
    meta: {
      breadcrumbs: [
        { text: 'E. 報告書の出力', to: { name: 'reportEditStep1' }, exact: true },
        { text: '報告書記載項目の入力' },
      ],
    },
  },
  {
    path: '/reports/:id/step3',
    name: 'reportEditStep3',
    component: ReportForm,
    props: route => ({
      step: 3,
      id: route.params.id,
    }),
    meta: {
      breadcrumbs: [
        { text: 'E. 報告書の出力', to: { name: 'reportEditStep1' }, exact: true },
        { text: '報告書の出力' },
      ],
    },
  },
]
